import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { HttpErrorResponse } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { OrganizationDetailsService } from '@services/organization-details.service';
import { EmrActions } from '@store/actions/emr/emr.actions';
import { parseProblemDetailsError } from '../../../utils/api-error.util';

@Injectable()
export class EmrEffects {

  loadEmrs$ = createEffect(() =>
    this.actions$.pipe(
      ofType(EmrActions.loadEmrs),
      switchMap(() =>
        this.organizationService.getEmrs().pipe(
          map((emrs) => EmrActions.loadEmrsSuccess({ emrs })),
          catchError((error: HttpErrorResponse) =>
            of(EmrActions.loadEmrsFailure({ error: parseProblemDetailsError(error, 'Failed to load EMR list') }))
          )
        )
      )
    )
  );

  constructor(
    private readonly actions$: Actions,
    private readonly organizationService: OrganizationDetailsService,
  ) {}
}
